export enum RackPositionEnum {
    BACK_CENTER = "Back Center",
    FRONT_CENTER = "Front Center",
    FRONT_LEFT = "Front Left",
    FRONT_RIGHT = "Front Right",
    BACK_LEFT = "Back Left",
    BACK_RIGHT = "Back Right"
}